<template>
    <div class="single-proposal">
        <h1 v-if="proposal && !isMobileDetailShown">Заявка на проектную инициативу</h1>
        <h1 v-if="proposalError">{{ proposalError }}</h1>
        <div class="proposal-contents" v-if="proposal">
            <div
                class="controls"
                v-if="!isMobileDetailShown && proposal.id !== null"
            >
                <Button
                    class="btn_details"
                    outline
                    @click="isMobileDetailOpen = true"
                >Детали заявки</Button>
                <Button
                    outline
                    class="btn_delete"
                    icon="trash"
                    @click="deleting = true"
                />
            </div>
            <MobileDetails
                v-if="isMobile"
                v-show="isMobileDetailShown"
                @close="isMobileDetailOpen = false"
            />
            <div
                v-else
                class="details"
                v-show="proposal.id !== null"
            >
                <div class="card">
                    <Logs></Logs>
                    <CreateComment
                        v-if="isCommentsEnabled"
                        :status="proposalStatus"
                    >
                    </CreateComment>
                </div>
                <Button
                        v-if="!isMobile"
                        class="red btn_delete"
                        outline
                        data-voicetext="Удалить заявку"
                        @click="deleting = true"
                >Удалить заявку</Button>
            </div>
            <div class="general" v-if="!isMobileDetailShown">
                <Form :disabled="disabled"></Form>
            </div>
        </div>

        <Dialog
                v-model="deleting"
                :scrollable="false"
                :has-close-button="false"
        >
            <div class="proposal-popup">
                <h1>
                    Уверены, что хотите удалить заявку?
                </h1>
                <div class="buttons">
                    <Button
                        class="btn btn--cancel"
                        outline
                        data-voicetext="Отмена"
                        @click="deleting = false"
                    >Отмена</Button>
                    <Button
                        class="btn"
                        data-voicetext="Удалить"
                        @click="onDelete"
                    >Удалить</Button>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import Logs from './widgets/Logs';
import CreateComment from './widgets/CreateComment';
import Form from './widgets/Form';
import MobileDetails from './widgets/MobileDetails';

import Button from '@/components/UI/Button';
import Dialog from '@/components/UI/Dialog';

const getters = ['isMobile'];
const actions = [
    'showPopup',
];

export default {
    name: 'WideSingleProposal',
    components: {
        Logs,
        CreateComment,
        Form,
        Button,
        MobileDetails,
        Dialog,
    },
    data: () => ({
        isMobileDetailOpen: false,
        deleting: false,
    }),
    computed: {
        ...mapGetters(getters),
        ...mapGetters('proposals', [
            'proposalStatus',
        ]),
        ...mapState('proposals', [
            'proposal',
            'proposalError',
            'isCommentsEnabled',
        ]),
        disabled() {
            return [1, 2, 4, 5, 6].includes(this.proposalStatus);
        },
        isMobileDetailShown() {
            return this.isMobile && this.isMobileDetailOpen;
        },
    },
    props: {
    },
    methods: {
        ...mapActions(actions),
        ...mapActions('proposals', [
            'loadProposal',
            'initProposal',
            'clearProposal',
            'deleteProposal',
        ]),
        async onDelete() {
            try {
                await this.deleteProposal();
            } finally {
                this.deleting = false;
                this.$router.push('/account/main');
            }
        },
    },
    async mounted() {
        this.clearProposal();
        const routerName = this.$router.history.current.name;
        if (this.$route.params.id === 'create' || routerName === 'account-proposal-create') {
            this.initProposal();
        } else {
            await this.loadProposal(this.$route.params.id);
        }
    },
};
</script>

<style lang="scss">
    @import '../../styles/rem';

    .single-proposal {
        h2 {
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #98A0A9;
            margin-bottom: rem(24);

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
                margin-bottom: mrem(24);
            }
        }
    }


    .proposal-popup {
        h1 {
            font-style: normal;
            font-size: rem(28);
            line-height: rem(36);
            text-align: center;
            color: #2A2626;

            @media (max-width: $vm) {
                font-size: mrem(28);
                line-height: mrem(36);
            }
        }
        p {
            font-size: rem(18);
            line-height: rem(26);
            text-align: center;
            color: #2A2626;

            @media (max-width: $vm) {
                font-size: mrem(18);
                line-height: mrem(26);
            }
        }
        .btn {
            width: 100%;

            &--cancel {
                color: #98A0A9;
                border: 1px solid #98A0A9;
                margin-right: rem(24);

                @include on-mobile {
                    margin-top: mrem(16);
                    margin-right: 0;
                }
            }
        }
        .buttons {
            display: flex;
            flex-direction: row;
            justify-content: space-around;

            @include on-mobile {
                flex-wrap: wrap;
                flex-direction: column-reverse;
            }
        }
    }
</style>

<style lang="scss" scoped>
    @import '../../styles/rem';

    .single-proposal {
        margin-right: rem(189);
        margin-left: rem(189);
        margin-bottom: rem(40);

        @include on-mobile {
            margin-right: 0;
            margin-left: 0;
        }

        .proposal-contents {

            display: flex;
            flex-direction: row-reverse;
            justify-content: flex-end;
            align-items: flex-start;
            margin-top: rem(32);

            @include on-mobile {
                flex-wrap: wrap;
                flex-direction: row;
                margin-top: 0;
            }

            .general {
                background: #FFFFFF;
                box-shadow: 0 rem(2) rem(8) rgba(155, 161, 166, 0.23626);
                border-radius: rem(4);
                padding: rem(48) rem(40);
                width: rem(1028);
                margin-right: rem(40);

                @include on-mobile {
                    padding: rem(8) rem(8);
                    width: 100%;
                    margin-right: 0;
                }
            }

            .details {
                width: rem(474);

                @include on-mobile {
                    width: 100%;
                }

                .card {
                    background: #FFFFFF;
                    box-shadow: 0 rem(6) rem(10) rgba(131, 134, 163, 0.12);
                    backdrop-filter: blur(rem(4));
                    border-radius: rem(4);
                    margin-bottom: rem(32);
                    padding: rem(24) rem(24) rem(40);
                }
            }
        }
    }

    h1 {
        font-weight: 600;
        font-size: rem(36);
        line-height: rem(44);
        color: #2A2626;

        @include on-mobile {
            margin-left: mrem(16);
            margin-right: mrem(16);
            font-size: mrem(30);
            line-height: mrem(38);
        }
    }

    .controls {
        display: none;

        @include on-mobile {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            margin: 0 mrem(16) mrem(32);
        }
    }

    .btn_delete {
        background-color: #FFFFFF!important;

        @include on-mobile {
            border-radius: mrem(4);
            color: #EF627D;
            border: 1px solid #EF627D;
            height: mrem(40);
            width: mrem(40);
        }
    }

    .btn_details {
        @include on-mobile {
            background: #FFFFFF;
            border-radius: mrem(4);
            border: 1px solid #4663AB;
            min-height: rem(40);
            width: mrem(295);
            height: mrem(40);
        }
    }

</style>
